import { render, staticRenderFns } from "./CreateEducationMajor.vue?vue&type=template&id=4fc6999b&"
import script from "./CreateEducationMajor.vue?vue&type=script&lang=js&"
export * from "./CreateEducationMajor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports